export const defaultSiteProposalValidationResults = {
  updated: false,
  about: {
    proposalPurpose:true,
    proposalDetails: true,
    consultationWithBiodiversityKnowledgeHolders: true,
    consultationWithPreviousProposers: true,
    consultationWithGovernment: true,
    consultationWithCustomaryLegalRightsHolders: true,
    contributorsAssessment: true,
  },
  details: {
    AltitudeOfBathymetryId: true,
    CoverageOfProtectedAreasId: true,
    siteSystems: true,
    country: true,
    deliniationRationale: true,
    boundary_source: true,
    highestAltitude: true,
    howIsTheSiteManaged: true,
    lowestAltitude: true,
    name: true,
    rationaleForSiteInformation: true,
    siteDescription: true,
    sensitiveSiteDetails: true,
    siteNameNational: true,
    coveredByWhatProtectedAreas: true,
    SiteDetailsCountryId: true,
    overlapOECMProtectedCoverage: true,
    consultationWithContributors: true,
    level1Habitat: true,
    level2Habitat: true,
    level3Habitat: true,
    habitatPercentage: true
  },
  ecoSystem: {
    EcoSystemRedListId: true,
    assessmentDate: true,
    dataSource: true,
    extentAtSiteBest: true,
    globalExtent: true,
    name: true,
    number: true
  },
  criterionC: {
    ecoregion_id: true,
    year: true,
    evidence_intact_ecology: true,
    evidence_low_human_impact: true,
    ecoregion_c_sites_count: true,
    trigger_reason_id: true,
    trigger_reason_text: true,
  },
  criterionE: {
    irreplaceability_assessment_approved: true,
    year: true,
    irreplaceability_score: true,
    trigger_reason_id: true,
    trigger_reason_text: true,
  },
  species: {
    scientificName: true,
    specieName: true,
    EcoBioRegionRestrictedId: true,
    SeasonalDistributionId: true,
    aggregationPredictabilityHeldInOneOrMoreLifeCycles: true,
    oneOf10LargestAggregationsAsCriteria: true,
    numberOfAssessmentParameters: true,
    supportedBySiteAsRefugium: true,
    producedBySiteAsRecruitmentSource: true,
    regularlyHeldInOneOrMoreLifeCycles: true,
    globallyMostImportantHabitat: true,
    sourceOfBeingGloballyMostImportant5PercentOccupiedHabitat: true,
    sourceOfBeingOneOf10LargestAggregation: true,
    oneOf10LargestAggregations: true,
    justificationThatTheSpeciesAggregated: true,
    justifyRefugium: true,
    justifyRecruitmentSourcess: true,
    reasonForSelectionDCriteria: true,
    triggerReasonId:true,
    sensitiveAtSite: true,
    sensitiveAtSiteSource: true,
    rationalForReassessmentSpecies: true,
  },
  assessmentParameters: {
    DerivationOfEstimateId: true,
    bestGlobal: true,
    bestSite: true,
    sourceGlobalData: true,
    sourceOfData: true,
    SeasonalDistributionId: true,
    natureOfOccurence: true,
    earliestDataSetYear: true,
    speciesPresenceEvidence: true,
    yearPresenceEvidence: true,
    ruCompromisedOf: true,
    ruSource: true,
    justification: true
  },
  congregations: {
    best: true
  }
}